import React from "react";
import "./style.css";

const ItemDetails = ({
  img,
  //precio,
  nombre,
  //categoria,
  novedades,
  oferta,
  id,
  descripcionItem,
  urlMercadoLibre,
}) => {
  
  let toogleClaseOfferta = "";
  let showOferta = "";
  
  if (oferta) {
    toogleClaseOfferta = "offerSign";
    showOferta = "oferta";
  }
    
  return (
    <div className="contenedor-itemDetails">
      <img src={img} alt="item" />
      <div className="contenedor-descripcion">
        {/*<h3>{precio}$</h3> */}
        <h2>{nombre}</h2>
        <p>{descripcionItem}</p>
        <a href={urlMercadoLibre} target="_blank" rel="noopener noreferrer" >
          Ver en Mercado Libre
        </a>
        <div className={toogleClaseOfferta}>
          <span>{showOferta}</span>
        </div>
      </div>
    </div>
  );
};

export default ItemDetails;
